"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = KevelBannerPreviewer;
const react_1 = __importDefault(require("react"));
const BannerErrors_1 = __importDefault(require("./BannerErrors/BannerErrors"));
const AppHomeCarouselBannerPreviewer_1 = __importDefault(require("./AppHomeCarouselBannerPreviewer/AppHomeCarouselBannerPreviewer"));
const OrderConfirmationBannerPreviewer_1 = __importDefault(require("./OrderConfirmationBannerPreviewer/OrderConfirmationBannerPreviewer"));
const DuplexBannerPreviewer_1 = __importDefault(require("./DuplexBannerPreviewer/DuplexBannerPreviewer"));
function KevelBannerPreviewer(props) {
    const { errors } = props;
    if (errors && errors.length > 0) {
        return react_1.default.createElement(BannerErrors_1.default, { errors: errors });
    }
    switch (props.placement) {
        case "Home":
            return props.home ? (react_1.default.createElement(AppHomeCarouselBannerPreviewer_1.default, Object.assign({}, props.home))) : null;
        case "OrderConfirmation":
            return props.orderConfirmation ? (react_1.default.createElement(OrderConfirmationBannerPreviewer_1.default, Object.assign({}, props.orderConfirmation))) : null;
        case "CategoryDuplexSmall":
        case "CategoryDuplexLarge":
            return props.categoryDuplex ? (react_1.default.createElement(DuplexBannerPreviewer_1.default, Object.assign({}, props.categoryDuplex))) : null;
        default:
            return null;
    }
}
